<template>
  <div>
    <b-breadcrumb :items="items" />
    <b-tabs>
      <b-tab title="Catalogues" active>
        <printers-catalogue-table></printers-catalogue-table>
      </b-tab>
      <b-tab title="Servers &amp; Printers">
        <printers-server-table></printers-server-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import PrintersServerTable from "@/components/printers/ServerTable";
import PrintersCatalogueTable from "@/components/printers/CatalogueTable";

export default {
  components: {
    "printers-server-table": PrintersServerTable,
    "printers-catalogue-table": PrintersCatalogueTable,
  },
  data() {
    return {
      items: [
        {
          text: "Home",
          active: true,
        },
      ],
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Main.vue